module.exports = __webpack_public_path__ + "static/media/bytt-nn-3.398db343.m4a";